<template>
  <div class="calendar_window">
    <div @click="viewCalendarEvent">
      <span>
        <span class="icon ic22-dateRange action-icon-calendar"></span>
      </span>
    </div>
    <div>
      <b-modal id="calendar-event-popup" class="full_screen_modal" ref="calendarEventModal" :header-bg-variant="'set-calendar-event-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt head_txt">
            <span v-if="userIds.length > 1">Setting Calendar Event For {{userIds.length}} People</span>
            <span v-else>{{sendGroupEventText}}</span>
          </div>
          <div>
            <button class="btn_close" aria-label="close" @click="cancelCalendarEvent">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div class="text-center mb-3">
          <span>{{sendGroupEventText}}</span>
        </div>

        <div class="cal_flds_container">

          <div class="row fld_row">
            <div class="col-12 fld_label">When <sup>*</sup></div>
            <div class="col-12 fld_input cal_dt">
              <datetime
                type="datetime" v-model="eventDateTime"
                :format="{year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: '2-digit'}"
                value-zone="America/New_York"
                zone="America/New_York"
                :hour-step="1"
                :minute-step="5"
                :min-datetime="minDatetime"
                :week-start="7"
                use12-hour
                auto
                input-style="">
              </datetime>
              <span class="icon fas fa-calendar-alt action-icon-calendar"></span>
            </div>
          </div>

          <div class="row fld_row">
            <div class="col-12 fld_label">What <sup>*</sup></div>
            <div class="col-12 fld_input">
              <b-form-input v-model.trim="eventSummary"></b-form-input>
            </div>
          </div>

          <div class="row fld_row">
            <div class="col-12 fld_label">Where <sup>*</sup></div>
            <div class="col-12 fld_input">
              <b-form-input v-model.trim="eventLocation"></b-form-input>
            </div>
          </div>

          <div class="float-right">
            <b-button @click="saveToCalendar" :disabled="$v.$invalid">Save Calendar Event</b-button>
          </div>

        </div> <!-- .cal_flds_container -->


      </b-modal>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import {  mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import { Datetime } from 'vue-datetime'
  import 'vue-datetime/dist/vue-datetime.css'
  import { required } from 'vuelidate/lib/validators'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'calendar-event-action-menu',
    props: ['userIds', 'senderId'],
    components: {
      Datetime
    },
    data: (vm) => {
      return {
        eventSummary: '',
        eventLocation: '',
        eventDateTime: '',
        sendGroupEventText: '',
        groupEventUserNames: [],
        isActionModalVisible: false,
        minDatetime: DateTime.utc().toISO(),
        userId: vm.senderId || localStore.getItem('userid')
      }
    },
    validations () {
      return {
        eventSummary: {
          required
        },
        eventLocation: {
          required
        },
        eventDateTime: {
          required
        }
      }
    },
    methods: {
      ...mapActions([
        'loadSaveCalendarEvent',
        'loadParticipantDisplayNames'
      ]),
      showLoader () {
        if (this.$root.$refs.loadingModal) {
          this.$root.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$root.$refs.loadingModal) {
          this.$root.$refs.loadingModal.hide()
        }
      },
      async viewCalendarEvent () {
        let userUuids = _.map(this.userIds, 'userUuid')
        let uuidDisplayNameMap = await this.loadParticipantDisplayNames(userUuids)
        let modalPageLayer = $('.advisee_sec_crd')
        this.groupEventUserNames = Object.values(uuidDisplayNameMap)
        this.sendGroupEventText = 'Setting Calendar Event For '
        if (userUuids.length > 1) {
          this.sendGroupEventText += userUuids.length + ' people including ' + this.groupEventUserNames.join(', ').replace(/,(?=[^,]*$)/, ' and')
        } else {
          this.sendGroupEventText += this.groupEventUserNames[0]
        }
        this.isActionModalVisible = true
        this.$refs.calendarEventModal.show()
        modalPageLayer.addClass('active')
      },
      cancelCalendarEvent () {
        this.eventSummary = ''
        this.eventLocation = ''
        this.eventDateTime = ''
        this.sendGroupEventText = ''
        this.groupEventUserNames = []
        this.isActionModalVisible = false
        this.$refs.calendarEventModal.hide()
        this.$parent.$parent.selectedUserUuids = []
        this.$parent.$parent.selectedItemMessage=''
        this.$parent.$parent.pageSelected = false
        let modalPageLayer = $('.advisee_sec_crd')
        modalPageLayer.removeClass('active')
      },
      formatDate (selected) {
        return DateTime.fromISO(selected, {zone: 'America/New_York'}).toFormat('ccc LLL dd, yyyy h:mm a (ZZZZ)')
      },
      async saveToCalendar () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          let text = '<b><sup>*</sup></b> fields are required'
          this.showNotification(text, 'error')
          return
        }
        this.showLoader()
        let userUuids = _.map(this.userIds, 'userUuid')
        let data = {
          participants: userUuids,
          title: this.eventSummary,
          location: this.eventLocation,
          description: this.eventSummary,
          startDateTime: this.eventDateTime,
          formattedStartDateTime: this.formatDate(this.eventDateTime)
        }
        let text = 'Calendar Event Sccessfully Saved For <strong>' + this.groupEventUserNames.join(', ') + '</strong>'
        let resp = await this.loadSaveCalendarEvent(data)
        if (resp) {
          this.hideLoader()
          this.cancelCalendarEvent()
          this.showNotification(text, 'success')
        } else {
          this.showNotification('Something went wrong.', 'error')
        }
      },
      showNotification (text, type) {
        this.$notify({
          group: 'notify',
          type: type,
          title: '',
          text: text
        })
      }
    }
  }
</script>

<style>
  .action-icon-calendar {
    font-size: 30px;
    margin-top: -3px;
    margin-left: -2px;
    display: block;
  }

  .action-icon-calendar:hover {

  }

  .popup_head_txt {
    font-weight: 800;
    font-size: 1.4rem;
  }

  .bg-set-calendar-event-popup-header {

  }

  sup {
    color: #ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/CalendarEventActionMenu.vue